import * as React from 'react'
import { useDebouncedCallback } from 'use-debounce'

import { Control, useWatch } from '~shared/segments/Form'

import { useCartUpdateCtx } from '../../Cart'
import { TOrderForm } from '../contexts/FormProvider'

type TProps = {
  control: Control<TOrderForm, object>
}

// these fields can possibly identify the customer
const contactFormFields: RoA<keyof TOrderForm> = [
  `givenName`,
  `familyName`,
  `phonePrefix`,
  `phoneNumber`,
  `email`,
]

// do not refetch on every keystroke, waiting for some time should not be a problem here
const REFETCH_DEBOUNCE_MS = 1000

/**
 * Because some sale actions might be bound to the customers order history
 * (eg. discount on first/second order for each customer)
 * the contact info input might change the content of the Cart.
 * -> To present the possible difference, we need to reQ the Cart
 * when the user changes his’s contact info (and might get recognized).
 */
export const useRefetchCartOnFormUpdate = ({ control }: TProps) => {
  const { refetch } = useCartUpdateCtx()

  const contactInputs = useWatch({
    control,
    name: contactFormFields,
  })

  // refetch only after some delay in changes
  const debouncedRefetch = useDebouncedCallback(refetch, REFETCH_DEBOUNCE_MS)

  // connect the debounced refetch to the contact input changes
  React.useEffect(() => {
    debouncedRefetch()
  }, [debouncedRefetch, contactInputs])

  return null
}
